<main class="container-fluid">
  <div class="center">
    <div class="grid">

      <div class="col" style="max-width: 40rem; margin: auto;">
        <h1 class="h3 mt-5 mb-0 font-weight-normal">Password reset sent</h1>

        <p>We've emailed you instructions for setting your password, if an account exists with the email you entered.
          You
          should receive them shortly.</p>

        <p>If you don't receive an email, please make sure you've entered the address you registered with, and check
          your
          spam folder.</p>
      </div>
    </div>
  </div>
</main>
